const s = (t) => t / 100, i = (t) => parseFloat(Math.round(t * 100).toFixed(0)), c = (t, e) => {
  if (t) {
    const r = typeof t == "number" ? t : Number(t);
    return e == "cents" ? i(r) : e == "dollars" ? s(r) : r;
  } else
    return t;
}, f = (t) => typeof t == "number" ? t.toFixed(2) : parseFloat(t).toFixed(2);
function u(t, e) {
  var o;
  const r = typeof t == "number" ? t.toString().replace(/[^0-9.]/g, "") : t.replace(/[^0-9.]/g, ""), n = new RegExp("^-?\\d+(?:.\\d{0," + (e || -1) + "})?");
  return ((o = r == null ? void 0 : r.match(n)) == null ? void 0 : o[0]) ?? "";
}
function l(t, e) {
  if (!t || isNaN(t)) return "$0.00";
  let r = "";
  const n = t < 0, o = Math.abs(t);
  o % 100 < 10 ? r = Math.floor(o / 100) + `.0${o % 100}` : r = Math.floor(o / 100) + "." + o % 100;
  let a = r.replace(/\d(?=(\d{3})+\.)/g, "$&,");
  return e && (a = a.replace(/\.00$/, "")), `$${n ? "-" : ""}${a}`;
}
function d(t) {
  let e = t;
  e || (e = 0), typeof e == "string" && (e = Number(e.replace(/[^0-9.]/g, "")));
  try {
    return Math.round(e * 100);
  } catch {
    return 0;
  }
}
function p(t, e) {
  return l(t, e).replace(/,/g, "");
}
const g = (t) => {
  if (t)
    return t < 0 ? `-${l(Math.abs(t))}` : l(Math.abs(t));
};
export {
  l as centsToDollar,
  p as centsToDollarWithoutComma,
  d as dollarToCents,
  g as formatNegativeAmounts,
  u as toFixed,
  f as toFixedNumber,
  c as transformCurrency
};
